import { NgModule } from '@angular/core';
import { CompanyStoreModule } from './store';

@NgModule({
  imports: [CompanyStoreModule],
})
export class CompanyDataAccessModule {}
